import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=c422fe20&scoped=true&"
import script from "./ProgressBar.vue?vue&type=script&lang=ts&"
export * from "./ProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=c422fe20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c422fe20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c422fe20')) {
      api.createRecord('c422fe20', component.options)
    } else {
      api.reload('c422fe20', component.options)
    }
    module.hot.accept("./ProgressBar.vue?vue&type=template&id=c422fe20&scoped=true&", function () {
      api.rerender('c422fe20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/ProgressBar.vue"
export default component.exports